<template>
  <div>
    <PhotoStatsHeader
      :sdate="sdate"
      :edate="edate"
      :bwphotos="bwphotos"
      :colorphotos="colorphotos"
      :up="up"
      :tp="tp"
      :devices="devices"
      @update="handleUpdate"
      @export="handleExport"
    />

    <div class="bg-white rounded shadow-sm">
      <div
        v-if="isLoading"
        class="d-flex justify-content-center align-items-center"
        style="height: 40vh"
      >
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div
        v-else-if="!chartData.length"
        class="d-flex justify-content-center align-items-center"
        style="height: 40vh"
      >
        <div class="text-muted">No data available.</div>
      </div>

      <PhotoStatsChart v-else :data="chartData" ref="photoChart" />
    </div>

    <div class="bg-white rounded shadow-sm p-3 mt-3 mb-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-3 mb-md-0">
          <div class="mb-3 mt-2">Total photos: {{ totalPhotos ?? 0 }}</div>
          <div class="mt-2">Total money: {{ totalMoney ?? "0,00" }} ₾</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportService from "@/services/reportService";
import PhotoStatsHeader from "@/components/PhotoStats/PhotoStatsHeader.vue";
import PhotoStatsChart from "@/components/PhotoStats/PhotoStatsChart.vue";

export default {
  name: "PhotoStats",
  components: {
    PhotoStatsHeader,
    PhotoStatsChart,
  },
  data() {
    const now = new Date();
    return {
      sdate: new Date(now.setDate(now.getDate() - 7))
        .toISOString()
        .substring(0, 10),
      edate: new Date().toISOString().substring(0, 10),
      bwphotos: true,
      colorphotos: true,
      up: 1,
      tp: 0,
      device: 0,
      chartData: [],
      totalPhotos: null,
      totalMoney: null,
      isLoading: false,
      devices: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const payload = {
        sdate: this.sdate,
        edate: this.edate,
        up: this.up,
        tp: this.tp,
        clientSel: 0,
        device: this.device,
        colorphotos: this.colorphotos ? 1 : 0,
        bwphotos: this.bwphotos ? 1 : 0,
      };

      this.isLoading = true;

      try {
        const res = await reportService.getPhotoStats(payload);
        this.chartData = res.data;
        this.devices = res.devices;
        this.totalPhotos = res.total_photos;
        this.totalMoney = res.total_money;
      } catch (e) {
        console.error("Error loading photo stats:", e);
      } finally {
        this.isLoading = false;
      }
    },
    async handleExport(filters) {
      const payload = {
        sdate: filters.sdate,
        edate: filters.edate,
        colorphotos: filters.colorphotos ? 1 : 0,
        bwphotos: filters.bwphotos ? 1 : 0,
        clientSel: 0,
        device: filters.device,
        lang: filters.lang || "ge",
        up: filters.up,
        tp: filters.tp,
      };

      if (filters.format === "xlsx") {
        try {
          const response = await reportService.getPhotoStatsXlsx(payload);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `photo-stats-${payload.sdate}_to_${payload.edate}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (e) {
          console.error("Export failed:", e);
        }
      } else if (filters.format === "doc") {
        const queryParams = new URLSearchParams(payload).toString();
        const downloadUrl =
          process.env.VUE_APP_API_BASE_URL +
          `/report/photo-stats/export-doc?${queryParams}`;

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          `photo-stats-${payload.sdate}_to_${payload.edate}.docx`
        );
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Unsupported export format:", filters.format);
      }
    },
    handleUpdate({ sdate, edate, bwphotos, colorphotos, up, tp, device }) {
      this.sdate = sdate;
      this.edate = edate;
      this.bwphotos = bwphotos;
      this.colorphotos = colorphotos;
      this.up = up;
      this.tp = tp;
      this.device = device;
      this.fetchData();
    },
  },
};
</script>
